import { RouterOptions, RouteRecordRaw } from 'vue-router';
import type { RouterConfig } from '@nuxt/schema'

// 这些是需要移除的nuxt自动生成的路由
const ExcludePath = [/^\/nft/];

// 这些是我们重写的路由
const routesEx: RouterOptions['routes'] = [
  // {
  //   path: '/:lang',
  //   name: 'index-lang',
  //   component: () => import('../pages/index/[lang]/index.vue'),
  // },
  // nft 重定向
  {
    path: '/nft/:lang/:id',
    redirect: (to) => {
      const { lang, id } = to.params;
      return {
        path: `/nft/${id}/${lang}`,
      };
    },
  },
  {
    path: '/nft',
    name: 'nft',
    children: [
      {
        path: ':lang',
        redirect: (to) => {
          const { lang } = to.params;
          return {
            path: `/nft/home/${lang}`,
          };
        },
      },
      {
        path: 'home/:lang',
        name: 'nft-home-lang',
        meta: { layout: 'nft' },
        component: () => import('../pages/nft/[[lang]]/home.vue'),
      },
      {
        path: 'collectible/:lang',
        name: 'nft-collectible-lang',
        meta: { layout: 'nft' },
        component: () => import('../pages/nft/[[lang]]/collectible.vue'),
      },
      {
        path: 'goods-detail/:lang',
        name: 'nft-goods-detail-lang',
        meta: { layout: 'nft' },
        component: () => import('../pages/nft/[[lang]]/goods-detail.vue'),
      },
      {
        path: 'marketplace/:lang',
        name: 'nft-marketplace-lang',
        meta: { layout: 'nft' },
        component: () => import('../pages/nft/[[lang]]/marketplace.vue'),
      },
      {
        path: 'creator/:lang',
        name: 'nft-creator-lang',
        meta: { layout: 'nft' },
        component: () => import('../pages/nft/[[lang]]/creator.vue'),
      },
      {
        path: 'usercenter/:lang',
        name: 'nft-usercenter-lang',
        meta: { layout: 'nft' },
        component: () => import('../pages/nft/[[lang]]/usercenter.vue'),
      },
      {
        path: 'sale/:lang',
        name: 'nft-sale-lang',
        meta: { layout: 'nft' },
        component: () => import('../pages/nft/[[lang]]/sale.vue'),
      },
    ],
  },
  {
    path: '/p2p/merchant/apply/form/:lang',
    name: 'p2p-merchant-apply-form-lang',
    component: () => import('../pages/p2p/merchant/apply/form/[[lang]]/index.vue'),
  },
  // {
  //   path: '/academy',
  //   name: 'academy',
  //   children: [
  //     {
  //       path: ':lang',
  //       name: 'academy-lang',
  //       meta: { i18n: 'academy' },
  //       component: () => import('../pages/academy/index/[lang]/index.vue'),
  //     },
  //     {
  //       path: 'articles/:lang',
  //       name: 'academy-articles-lang',
  //       meta: { i18n: 'academy' },
  //       component: () => import('../pages/academy/articles/[lang]/index.vue'),
  //     },
  //     {
  //       path: 'detail/:lang',
  //       name: 'academy-detail-lang',
  //       meta: { i18n: 'academy' },
  //       component: () => import('../pages/academy/detail/[lang]/index.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/vip/:lang',
  //   name: 'vip-lang',
  //   component: () => import('../pages/vip/[[lang]]/index.vue'),
  // },
];

const filterNuxtRoutes = (route: RouteRecordRaw) => {
  if (routesEx.some((item) => route.path === item.path || route.name === item.name)) {
    return false;
  }
  if (route?.path.includes('/components') || route?.path.includes('/utils')) {
    return false;
  }
  return ExcludePath.find((exclude) =>
    exclude instanceof RegExp ? !route.path.match(exclude) : route.path === exclude
  );
};

export default <RouterConfig> {
  routes: (nuxtRoutes: RouterOptions['routes']) => {
    // console.log('nuxtRoutes >>', nuxtRoutes);
    // 对路由数据进行过滤处理
    const resRoutes = nuxtRoutes.filter((route) => filterNuxtRoutes(route)).concat(routesEx);
    // console.log('nuxtRoutes >>', nuxtRoutes, resRoutes);
    return resRoutes;
  },
};
